<template>
  <div>
    <common-dialog
      ref="dialog"
      width="400px"
      show-save-button
      edit-title
      unit="考勤忘刷报备"
      id-key="AttendanceTaskDtsId"
      :data="data"
      form-label-width="110px"
      :form-rules="rules"
      :save-func="api.taskFiling"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <!-- <el-col :span="12">
          
          <el-col :span="12">
            <el-form-item label="人员类别">
              
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年级">
              {{data.Grade}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="部门">
              {{data.DpName}}
            </el-form-item>
          </el-col> -->
          <el-col :span="24" v-if="type==0">
            <el-form-item label="签到报备时间" prop="SignInFilingTime">
              <el-time-picker
                v-model="data.SignInFilingTime"
                placeholder="选择日期"
                clearable
                style="width:100%;"
                format="HH:mm"
                value-format="HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24" v-else>
            <el-form-item label="签退报备时间" prop="SignOutFilingTime">
              <el-time-picker
                v-model="data.SignOutFilingTime"
                placeholder="选择时间"
                clearable
                style="width:100%;"
                format="HH:mm"
                value-format="HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="报备事件" prop="bbrq">
              <el-select v-model="data.bbsj" clearable size="mini">

              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报备类型">
              {{data.bblx?'签退':'签到'}}
            </el-form-item>
          </el-col> -->
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/attendance/teachersetting").default,
      data: {
        AttendanceTaskDtsId: 0,
        SignInFilingTime: "",
        SignOutFilingTime: "",
      },
      ed: "",
      s: "",
      e: "",
      type: 0,
      isMB: this.$store.state.isMB,
      rules: {
        FullName: [{ required: true, message: "请选择人员" }],
        SignInFilingTime: [{ required: true, message: "请选择报备时间" }],
        SignOutFilingTime: [{ required: true, message: "请选择报备时间" }],
      },
    };
  },
  methods: {
    onCreateOpened() {
      
    },
    onEditOpened(data) {
      console.log("????",data)
      this.data.AttendanceTaskDtsId = data.id;
      this.type = data.type;
      if(data.type==0) {
        this.data.SignOutFilingTime = data.so;
      } else {
        this.data.SignInFilingTime = data.si;
      }
      this.ed = this.$commonJs.toDateString(data.date);
      this.s = data.s;
      this.e = data.e;
    },
    onBeforeSave(data) {
      if(this.type==0) {
        var pick = new Date(this.ed + " " + this.data.SignInFilingTime);
      } else {
        var pick = new Date(this.ed + " " + this.data.SignOutFilingTime);
      }
      var s = new Date(this.s);
      var e = new Date(this.e);
      if(pick.getTime() < s.getTime() || pick.getTime() > e.getTime()) {
        this.$message.error("报备时间不能超出事件时段");
        return false;
      }
      if(this.type==0) {
        // this.data.SignInFilingTime = this.ed + " " + this.data.SignInFilingTime;
        // this.data.SignOutFilingTime = "";
      } else {
        var si = new Date(this.data.SignInFilingTime);
        if(pick.getTime() < si.getTime()) {
          this.$message.error("签退时间不能早于签到时间");
          return false;
        }
        // this.data.SignOutFilingTime = this.ed + " " + this.data.SignOutFilingTime;
        // this.data.SignInFilingTime = "";
      }
      var obj = {
        AttendanceTaskDtsId: this.data.AttendanceTaskDtsId,
        Type: this.type,
        SignInFilingTime: this.data.SignInFilingTime,
        SignOutFilingTime: this.data.SignOutFilingTime,
      };
      if(this.type == 0) {
        obj.SignInFilingTime = this.ed + " " + this.data.SignInFilingTime;
        obj.SignOutFilingTime = "";
      } else {
        obj.SignOutFilingTime = this.ed + " " + this.data.SignOutFilingTime;
      }
      this.loading(true);
      this.api.taskFiling(obj).then(res => {
        this.loading(false);
        if(res.Code==0) {
          this.$message.success("报备成功");
          this.close(true);
          this.$emit('close-saved');
        } else {
          this.$message.error(res.Msg);
        }
      })
      return false;
    },
    onClosed() {

    },
  },
};
</script>
<style lang="scss">
</style>